import React from 'react';
import ReactDOM from 'react-dom';
import "assets/scss/realtimeWidget.scss?v=0.0.1";
import RTL from 'components/RTL/RTL'



ReactDOM.render(
  <RTL />
  ,
  document.getElementById("root")
);